var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-16"},[_vm._v(_vm._s(_vm.title))]),_vm._t("header"),_c('div',{class:[_vm.flex ? _vm.styles.flex : _vm.styles.grid]},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }